import { HtmlParser } from '../html-parser/html-parser';
import { useMarkdown } from '../../../../hooks';
import { ReactNode } from 'react';

type MarkdownProps = {
  children?: ReactNode;
};

/**
 * Generic component that enables rendering Markdown,
 * otherwise known as Rich Text coming from the Strapi API
 * The content will pass through sanitation
 * @param children Raw markdown structure, as string
 */
function Markdown({ children }: MarkdownProps): JSX.Element {
  const md = useMarkdown();
  return <HtmlParser html={md(children as string)} />;
}

export { Markdown };
